<template>
    <div class="class-1">
      <!-- Header -->
      <app-header />
  
      <!-- Edit Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Edit Waiter</h2>
            <form @submit.prevent="handleSubmit">
              <!-- Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">Name</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="name" 
                    v-model="form.name" 
                    placeholder="Enter Waiter Name" 
                    required
                  >
                </div>
              </div>
  

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">Set New Passowrd</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="password" 
                    v-model="form.password" 
                    placeholder="Enter Password" 
                  >
                </div>
              </div>
              
              <!-- Branch Selection -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="branch">Branch</label>
                  <select 
                    class="form-control" 
                    id="branch" 
                    v-model="form.branchId" 
                    required
                  >
                    <option value="" disabled>Select Branch</option>
                    <option 
                      v-for="branch in branches" 
                      :key="branch.id" 
                      :value="branch.id"
                      :selected="branch.id === form.branchId"
                    >
                      {{ branch.name || 'Unnamed Branch' }} ({{ branch.ERP_CustomerName }})
                    </option>
                  </select>
                </div>
              </div>
  
              <!-- Status Toggle -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input 
                      type="checkbox" 
                      class="form-check-input" 
                      id="isSuspend" 
                      v-model="form.isSuspend"
                    >
                    <label class="form-check-label" for="isSuspend">Suspend this waiter</label>
                  </div>
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelEdit">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-primary">
                    Update Waiter
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          branchId: '',
          isSuspend: false,
        },
        branches: [],
        currentDate: '',
        currentTime: '',
        waiterId: null
      };
    },
    async created() {
      this.waiterId = this.$route.params.id;
      await this.fetchWaiter();
      await this.fetchBranches();
    },
    mounted() {
      this.updateDateTime();
      this.startDateTimeUpdate();
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      async fetchBranches() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken'); 
          const response = await fetch(`${this.$BASE_API_URL}/api/branches`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch branches');
          }
  
          const data = await response.json();
          this.branches = data.data;
        } catch (error) {
          console.error('Error fetching branches:', error);
          this.$toast.error('Failed to load branch data');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async fetchWaiter() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/waiters/${this.waiterId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch waiter data');
          }
  
          const { data } = await response.json();
          this.form = {
            name: data.name,
            branchId: data.branchId,
            isSuspend: data.isSuspend? true : false
          };
        } catch (error) {
          console.error('Error fetching waiter:', error);
          this.$toast.error('Failed to load waiter data');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async handleSubmit() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          if(this.form.branchId != localStorage.getItem('branchId')){
            const branchName = localStorage.getItem('branchName');
            this.$toast.error(`You can only add waiter to ${branchName}`);
            return;
          }
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/waiters/${this.waiterId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(this.form),
          });
  
          const data = await response.json();
  
          if (response.ok) {
            this.$toast.success('Waiter updated successfully!');
            this.$router.push('/waiters');
          } else {
            this.$toast.errors('Update failed: ' + (data.errors[0][0] || 'Unknown error'));
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      cancelEdit() {
        this.$router.push('/waiters');
      },
    },
  };
  </script>
  
  <style scoped>
  .form-control {
    margin-bottom: 15px;
  }
  .form-check {
    margin-top: 10px;
  }
  .btn {
    padding: 8px 20px;
  }
  </style>